import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Coordinates } from 'src/features/parkingManagement/types/parking';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

export const RESOURCE = '/parkings/parking-gateways/';

export enum GATEWAY {
    ENTRY = 'entry',
    EXIT = 'exit',
}

export type ParkingGateways = {
    id: string;
    parking: string;
    coordinates: Coordinates | null;
    gateway_type: GATEWAY;
    name: string;
    address: string;
    max_height_cm: number | null;
    max_width_cm: number | null;
};

interface DTO extends ListDTO {
    parking: string;
}

type QueryFnType = typeof queryFn;
const queryFn = (params: DTO): Promise<ListResponseSmartParkAPI<ParkingGateways>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetParkingGateways };
